import { Globe, X } from "lucide-react";

// "🌍 Translate this chat?" nudge (cc_24 parity) — shown when ≥2 of the last 10 incoming messages look
// foreign; dismissal is remembered per chat.
export function BabelNudge({ onEnable, onDismiss, busy }) {
  return (
    <div className="mx-3 mt-2 flex items-center gap-3 rounded-2xl border border-bloq-blue/30 bg-bloq-blue/10 px-3.5 py-2.5" data-testid="babel-nudge">
      <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-xl bg-bloq-blue/20 text-bloq-blue"><Globe className="h-4 w-4" /></span>
      <div className="min-w-0 flex-1">
        <div className="text-sm font-semibold text-white">Translate this chat?</div>
        <div className="text-xs text-bloq-muted">Messages here look like another language — Babel can auto-translate them for you.</div>
      </div>
      <button onClick={onEnable} disabled={busy} className="rounded-full bg-bloq-blue px-3 py-1.5 text-xs font-bold text-white hover:bg-bloq-blue/90 disabled:opacity-60" data-testid="babel-nudge-enable">Turn on</button>
      <button onClick={onDismiss} className="rounded-full p-1 text-bloq-muted hover:text-white" title="Not now" data-testid="babel-nudge-dismiss"><X className="h-4 w-4" /></button>
    </div>
  );
}
